<template>
  <el-dialog
    title="商家设置折扣"
    :visible.sync="dialogVisible"
    customClass="customWidth"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      size="mini"
    >
      <el-form-item
        prop="legal"
        label="商户名"
      >
        {{userName}}
      </el-form-item>




      <el-form-item
              prop="gyj_discount"
              label="折扣"
      >
        <el-select
                collapse-tags
                class="filter-item"
                v-model="form.gyj_discount"
                placeholder="请选折扣"
        >
          <el-option
                  v-for="item in type_itemArray"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>





    <el-form-item>
      <el-button
              type="primary"
              :loading="loading"
              @click="saveUser"
      >保存</el-button>
      <el-button @click="close">取消</el-button>
    </el-form-item>
    </el-form>
  </el-dialog>

</template>
<style>
  .customWidth{
    width:30%;
  }
</style>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as userService from "@/api/sys/user";
    import util from '@/libs/util.js';
export default {
  name: "twoagentyEditForm",
  props: {
      agent: Object,
    value: Boolean
  },
  data() {
    return {
      imgUrl: process.env.VUE_APP_API+"/moblieapp/currencyUpload",
      fileList: [],
      loading: false,
      dialogVisible: false,
        userName:"",
      type_itemArray: [
        {
          name: '9.9',
          value: '9.9'
        },
        {
          name: '不让折扣',
          value: '10'
        }
      ],
      form: {
          desc_content:"",
        gyj_discount:""
      }
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    dialogOpen() {
      this.$refs.form.resetFields();
      if (this.agent.agentid) {
        let form = {};
          this.userName = this.agent.agentname;

        form.gyj_discount = this.agent.gyj_discount;
        this.form = form;
      } else {
        this.form = {};
      }

    },



      saveUser() {
          this.$refs["form"].validate(valid => {
              if (valid) {
                  if (this.agent.agentid) {
                      this.loading = true;
                      agentService.savePagentidZktype({ ...this.form,agentid:this.agent.agentid})
                          .then(data => {
                              this.loading = false;
                              this.dialogVisible = false;
                              this.$emit("submit");
                          });
                  }
              } else {
                  return false;
              }
          });
      },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

